import React, { FC, PropsWithChildren, ElementType, KeyboardEvent } from 'react'
import { handleScreenReaderEnter } from 'lib/screenReader'
import useQA from 'hooks/useQA'
import styles from '../Polaroid.module.scss'
import classNames from 'classnames'

type PolaroidTextProps = {
  onClick?: () => void
  dataTestId?: string
  ariaLabel?: string
  customStyles?: string
  tag?: ElementType
}

const PolaroidText: FC<PropsWithChildren<PolaroidTextProps>> = ({
  children,
  onClick,
  dataTestId,
  ariaLabel,
  customStyles,
  tag: Tag = 'p',
}) => {
  const { testId } = useQA()

  const handleKeyDown = (ev: KeyboardEvent) => {
    if (!onClick) {
      return
    }
    if (handleScreenReaderEnter(ev)) onClick()
  }

  const isClickable = Boolean(onClick)

  return (
    <Tag
      className={classNames(styles.textGunmetalOpacity, customStyles)}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex={isClickable ? 0 : undefined}
      role={isClickable ? 'button' : undefined}
      aria-label={ariaLabel}
      {...(dataTestId ? testId(dataTestId) : {})}
    >
      {children}
    </Tag>
  )
}

export default PolaroidText
